import { authenticationService } from '../../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/Services/BaseService';

@Injectable({
  providedIn: 'root',
})
export class ActivityService extends BaseService {

constructor( http: HttpClient,  auth: authenticationService) {
  super(http, auth, 'activity');
 }
}
